import { render, staticRenderFns } from "./FormatRow.vue?vue&type=template&id=236ab950&scoped=true"
import script from "./FormatRow.vue?vue&type=script&lang=js"
export * from "./FormatRow.vue?vue&type=script&lang=js"
import style0 from "./FormatRow.vue?vue&type=style&index=0&id=236ab950&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236ab950",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('236ab950')) {
      api.createRecord('236ab950', component.options)
    } else {
      api.reload('236ab950', component.options)
    }
    module.hot.accept("./FormatRow.vue?vue&type=template&id=236ab950&scoped=true", function () {
      api.rerender('236ab950', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/simpleTable/FormatRow.vue"
export default component.exports